module.exports = __webpack_public_path__ + "img/pie-chart4.3e28ca1f.svg";